/**
 * Enumerable representing the CallbackTypes available
 */
export enum CallbackTypes {
  SUCCESS = 'success',
  CANCEL = 'cancel',
  BACK = 'back',
  FAILURE = 'failure',
  ERROR = 'error',
  NEEDS_VERIFICATION = 'needs_verification',
  UNCONFIRMED = 'Unconfirmed',
  AUTHORIZED = 'Authorized',
  REJECTED = 'Rejected',
  INVALIDATED = 'Invalidated',
  CREATED = 'Created',
}
